export default function ClientLogos() {
  const logos = [
    { name: "Fortune 500 Logistics", industry: "Logistics & Supply Chain" },
    { name: "TechScale SaaS", industry: "B2B SaaS" },
    { name: "Industrial Solutions", industry: "Manufacturing" },
    { name: "Professional Services Group", industry: "Consulting" },
  ];

  return (
    <section className="py-16 px-6 bg-dark-card border-y border-border/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-wider text-bronze font-semibold mb-2">
            Trusted By Leaders In
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            Logistics, SaaS, Manufacturing & Professional Services
          </h2>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="group flex flex-col items-center justify-center p-6 rounded-xl border border-border/20 bg-deep-navy/50 hover:border-bronze/40 hover:bg-deep-navy/80 transition-all duration-300 hover:scale-105"
            >
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan/20 to-bronze/20 flex items-center justify-center mb-3 group-hover:from-cyan/30 group-hover:to-bronze/30 transition-all">
                <span className="text-2xl font-bold text-cyan">
                  {logo.name.charAt(0)}
                </span>
              </div>
              <p className="text-xs text-medium-gray text-center">
                {logo.industry}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="text-sm text-light-gray/70 italic">
            Client names confidential — NDA protected partnerships
          </p>
        </div>
      </div>
    </section>
  );
}
